import { useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from '@hotjar/hotsauce';
import { TopBar } from '@hotjar/webapp/features/Activation/TopBar';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';
import { mark } from '@hotjar/performance';
import { MARKS } from '@hotjar/webapp/performance';

const SkipButton = styled(Button)`
  position: absolute;
  right: 20px;
`;

interface SetupWizardHeaderProps {
  className?: string;
  onSkip: () => void;
}

export const SetupWizardHeader = ({ className, onSkip }: SetupWizardHeaderProps): JSX.Element => {
  const { t } = useTranslation();
  const { click: trackClick } = useTrack();
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const handleOnSkip = (eventName = 'Confirm Skip Installation') => {
    mark(MARKS.SIGN_UP_DO_IT_LATER_SUBMISSION_START);
    trackClick(eventName, 'Type of Installation', {});
    onSkip();
  };

  return (
    <TopBar className={className}>
      <SkipButton kind="ghost" size="s" onClick={() => setConfirmationModalOpen(true)}>
        {t('activation:setup-wizard.do-it-later')}
      </SkipButton>
      <Modal
        size="s"
        contentLabel={t('activation:setup-wizard.skip-confirmation-modal.label')}
        isOpen={confirmationModalOpen}
        onClose={() => setConfirmationModalOpen(false)}
      >
        <Modal.Header title={t('activation:setup-wizard.skip-confirmation-modal.title')} />
        <Modal.Body>{t('activation:setup-wizard.skip-confirmation-modal.content')}</Modal.Body>
        <Modal.Footer>
          <Button
            aria-label={t('activation:setup-wizard.skip-confirmation-modal.install-now')}
            kind="ghost"
            onClick={() => setConfirmationModalOpen(false)}
          >
            {t('activation:setup-wizard.skip-confirmation-modal.install-now')}
          </Button>
          <Button
            aria-label={t(
              'activation:setup-wizard.skip-confirmation-modal.continue-without-installing',
            )}
            kind="danger"
            onClick={() => handleOnSkip()}
          >
            {t('activation:setup-wizard.skip-confirmation-modal.continue-without-installing')}
          </Button>
        </Modal.Footer>
      </Modal>
    </TopBar>
  );
};
